// extracted by mini-css-extract-plugin
export default {"slide":"---------packages-corgi-x-src-components-Slideshow-Slide-module__slide"};